module.exports = "https://cdn.realtymogul.com/static/media/down_blue.295500d0.svg";